import { useContext } from 'react';

import AccessContext from './Context';

const useAccess = () => {
    return useContext(AccessContext);
};

export default useAccess;
